import { Button } from "../../components/ui/button";
import PageHeader from "./sections/PageHeader";
import Banner from "./sections/PageBanner";
import Footer from "./sections/PageFooter";

function GetInvolvedWrapper() {
    return (
        <>
        <section className="w-full">
            <img 
            src="/images/support.jpg" 
            alt="Team" 
            className="w-full h-64 object-cover"
            />
        </section>
      <section className="bg-white">
        <div className="px-4 mx-auto max-w-(--breakpoint-lg) sm:py-16 lg:px-2">
          <div className="mb-8 text-center">
            <p className="text-lg text-gray-700 text-center font-light">
              Discover how you can support WITS in our
              fight for a better future for animals.
            </p>
          </div>
          <div className="grid grid-cols-1 mx-auto max-w-screen-xl md:grid-cols-2 lg:grid-cols-2 gap-8">
            <div className="border rounded-lg border-gray-400 hover:shadow-xl hover:cursor-pointer">
              <div className='mb-4 flex flex-row justify-center items-center'>
                <img src='/images/marine.jpg' className='aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300' alt='Judge' />
              </div>
              <h3 className="text-2xl text-center font-light text-green-600">Become a Volunteer</h3>
              <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                Join us as a volunteer and help make a difference in our various projects and initiatives.
              </p>
              <div className='mb-4 flex flex-row justify-center items-center'>
                <a href="mailto:info@lapa.africa?subject=Becoming a WITS Volunteer">
                  <Button size={"lg"} className="bg-green-600 text-white hover:bg-green-900">
                    Become a Volunteer &rarr;
                  </Button>
                </a>
              </div>
            </div>
            <div className="border rounded-lg border-gray-400">
              <div className='mb-4 flex flex-row justify-center items-center'>
                <img src='/images/penguin.jpg' className='aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300' alt='Advocacy' />
              </div>
              <h3 className="text-2xl text-center font-light text-green-600">Donate</h3>
              <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                Support our work by making a donation. <br /> Your contribution helps us continue our mission.
              </p>
              <div className='mb-4 flex flex-row justify-center items-center'>
                <Button size={"lg"} className="bg-green-600 text-white hover:bg-green-900">
                  Donate &rarr;
                </Button>
              </div>
            </div>
            <div className="border rounded-lg border-gray-400">
              <div className='mb-4 flex flex-row justify-center items-center'>
                <img src='/images/leopard.jpg' className='aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300' alt='Research' />
              </div>
              <h3 className="text-2xl text-center font-light text-green-600">Partner with Us</h3>
              <p className="text-gray-950 text-center mt-8 mb-8 font-light">
                Become a partner and collaborate with us on projects that promote sustainability and conservation.
              </p>
              <div className='mb-4 flex flex-row justify-center items-center'>
                <a href="mailto:info@lapa.africa?subject=Becoming a WITS Partner">
                  <Button size={"lg"} className="bg-green-600 text-white hover:bg-green-900">
                    Become a Partner &rarr;
                  </Button>
                </a>
              </div>
            </div>
            <div className="border rounded-lg border-gray-400">
              <div className='mb-4 flex flex-row justify-center items-center'>
                <img src='/images/elephant.jpg' className='aspect-video w-full overflow-hidden rounded-t-lg object-cover transition-all duration-300' alt='Research' />
              </div>
              <h3 className="text-2xl text-center font-light text-green-600">Leave a gift in your will</h3>
              <p className="text-gray-950 text-center mt-8 mb-8 font-light">
              Find out how you can join thousands worldwide who have left a legacy gift in their Will to WITS to help continue our essential work.
              </p>
              <div className='mb-4 flex flex-row justify-center items-center'>
                <a href="mailto:info@lapa.africa?subject=Becoming a WITS Partner">
                  <Button size={"lg"} className="bg-green-600 text-white hover:bg-green-900">
                    Leave a Gift &rarr;
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
        </>
    )
}

export default function GetInvolved(){
    return (
        <>
        <Banner />
        <PageHeader />
        <GetInvolvedWrapper />
        <Footer />
        </>
    )
}